import { Injectable } from '@angular/core';
import { of } from 'rxjs';
import { catchError, map, mergeMap, tap } from 'rxjs/operators';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { CrudService } from 'src/app/core/services/crud.service';
import { fetchDashboardCardsData, fetchDashboardCardsDataFailure, fetchDashboardCardsDataSuccess, fetchDashboardGraphStatsData, fetchDashboardGraphStatsDataFailure, fetchDashboardGraphStatsDataSuccess } from './dashboard.action';

@Injectable()
export class DashboardEffects {
  constructor(
    private actions$: Actions,
    private CrudService: CrudService,
  ) {}

  fetchDashbaordCardsData$ = createEffect(() =>
    this.actions$.pipe(
      ofType(fetchDashboardCardsData),
      mergeMap((action:any) =>
        this.CrudService.fetchData(`Admin/AdminDashBoardCard`).pipe(
          map((result) => fetchDashboardCardsDataSuccess({ response: result })),

          catchError((error) => of(fetchDashboardCardsDataFailure({ error })))
        )
      )
    )
  );

  fetchDashbaordGraphStatsData$ = createEffect(() =>
    this.actions$.pipe(
      ofType(fetchDashboardGraphStatsData),
      mergeMap((action:any) =>
        this.CrudService.fetchData(`Admin/AdminMonthlyGraphStats`).pipe(
          map((result) => fetchDashboardGraphStatsDataSuccess({ response: result })),

          catchError((error) => of(fetchDashboardGraphStatsDataFailure({ error })))
        )
      )
    )
  );
}
